// 顧客コード
import { atom } from "recoil";
import { AtomKeys } from "../recoilKeys";

// 顧客コードのAtom（データストア）
export const carSchoolIdState = atom<String | null>({
    key: AtomKeys.CAR_SCHOOL_ID_STATE,
    default: null,
});
